import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_CIC_FEE_REASONS_ACTION_TYPE } from '../actions';

const initialState = [];

const loanCicFeeReasonsReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case LOAN_CIC_FEE_REASONS_ACTION_TYPE.GET_LOAN_CIC_FEE_REASONS:
        return payload || initialState;

      case LOAN_CIC_FEE_REASONS_ACTION_TYPE.EDIT_LOAN_CIC_FEE_REASONS:
        return payload.cicFeeReasons;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanCicFeeReasonsReducer;
